import React from 'react';

import type { PageCardView } from 'api/vendorMarketplaceApi';

import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import TileScroller from '@zola/zola-ui/src/components/TileScroller';

import {
  CarouselContainer,
  CarouselTitle,
  CarouselTitleContainer,
  TileHeading,
  TileImage,
  TileImageContainer,
  TileLink,
  TileParagraph,
  TileTag,
  TileTextContainer,
} from './FeaturedArticlesCarousel.styles';

type FeaturedArticlesCarouselProps = {
  articles: PageCardView[];
  title?: string;
  viewAllHref?: string;
};

const FeaturedArticlesCarousel = ({
  articles,
  title,
  viewAllHref,
}: FeaturedArticlesCarouselProps): JSX.Element => {
  return articles.length > 0 ? (
    <CarouselContainer>
      <CarouselTitleContainer>
        <CarouselTitle>{title || 'Featured'}</CarouselTitle>
        {viewAllHref ? (
          <ButtonV3 component="a" href={viewAllHref}>
            View all
          </ButtonV3>
        ) : (
          <></>
        )}
      </CarouselTitleContainer>
      <TileScroller>
        {articles.map((article, i) => {
          const { heroImageset, href, title: articleTitle, tag, excerpt } = article;
          const [heroImage] = heroImageset;
          return (
            <TileLink href={href} key={i}>
              <TileImageContainer>
                <TileImage alt="" src={heroImage.url || ''} loading="lazy" />
              </TileImageContainer>
              <TileTextContainer>
                <TileHeading presentation="h6">{articleTitle}</TileHeading>
                {tag ? <TileTag>{tag}</TileTag> : <></>}
                {excerpt ? <TileParagraph>{excerpt}</TileParagraph> : <></>}
              </TileTextContainer>
            </TileLink>
          );
        })}
      </TileScroller>
    </CarouselContainer>
  ) : (
    <></>
  );
};

export default FeaturedArticlesCarousel;
